<header class="ui-page-header">
  <div class="ui-page-header__actions" role="group" [attr.aria-label]="actionsAriaLabel()">
    <ng-content />
  </div>
</header>
